/* eslint-disable */
import { jssPreset } from '@material-ui/core/styles';
import { create } from 'jss';
import rtl from 'jss-rtl';
import React from 'react';
import JssProvider from 'react-jss/lib/JssProvider';
import JssPropTypes from './Jss.component.props';
import generateClassName from './Jss.component.services';

/**
 * JssComponent
 * @export
 * @class JssComponent
 * @extends {React.Component<JssComponentComposedProps, JssComponentState>}
 */
export class JssComponent extends React.Component {
  /**
   * The `props` to seed when any specific prop receives an `undefined` value. **NOT** a `null` value
   * @static
   * @type {Partial<JssComponentProps>}
   * @memberof JssComponent
   */
  static defaultProps = {};

  /**
   * The name of the Component to display when debugging
   * @static
   * @type {`Jss`}
   * @memberof JssComponent
   */
  static displayName = `Jss`;

  /**
   * The values to use to apply runtime typechecking on the props
   * @static
   * @type {object}
   * @memberof JssComponent
   */
  static propTypes = JssPropTypes;

  /**
   * Data specific to the `<Jss />` instance
   * @type {JssComponentState}
   * @memberof JssComponent
   */
  state = {};

  /**
   * Create the `jss` to be used to be `<JssProvider />`
   * @returns {JSS} The `jss` instance
   * @memberof JssComponent
   */
  createJss = () => {
    return create({ plugins: [...jssPreset().plugins, rtl()] });
  };

  /**
   * Render the component
   * @returns {React.Component} The rendered `<Jss />`
   * @memberof JssComponent
   */
  render() {
    const { children } = this.props;
    return (
      <JssProvider generateClassName={generateClassName} jss={this.createJss()}>
        {children}
      </JssProvider>
    );
  }
}

/** @type {React.ComponentClass<JssComponentProps>} */
const Jss = JssComponent;

export default Jss;
